module.exports = __webpack_public_path__ + "img/weibo-code.10ece390.png";